import { Component, Input, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';
import { UigCartNotesDialogComponent } from './uig-cart-notes-dialog/uig-cart-notes-dialog.component';
import {OrderEntry} from '@spartacus/cart/base/root';
import {LaunchDialogService} from "@spartacus/storefront";
import {take} from "rxjs/operators";

interface UigOrderEntry extends OrderEntry {
  note?: string;
}

@Component({
    selector: 'app-uig-cart-notes',
    templateUrl: './uig-cart-notes.component.html',
    styleUrls: ['./uig-cart-notes.component.scss'],
    standalone: false
})
export class UigCartNotesComponent implements OnInit {

  @Input() cartItem: UigOrderEntry;
  @Input() cartId: string;
  @Input() readonly?: boolean = false;


  constructor(  private launchDialogService: LaunchDialogService) { }

  ngOnInit(): void { }

  public openNotesModal(cartItem: UigOrderEntry): void {
    if (!this.readonly) {
      const cartNotesDialogData = {
        entryNumber: cartItem.entryNumber,
        note: cartItem.note ?? '',
        cartId: this.cartId
      };
      const dialog = this.launchDialogService.openDialog('CART_NOTES', undefined, undefined, cartNotesDialogData);
      dialog?.pipe(take(1)).subscribe();
    }
  }
}
